import api from "../../client";
import {
  ContentBoxSectionEnum,
  ContentBoxesResponseData,
} from "../../types/contentBox";

export const contentBoxListRequest = async (
  section: ContentBoxSectionEnum,
  id: string | undefined,
) => {
  const { data } = await api.get<ContentBoxesResponseData>(
    `/${section}/${id}/content-boxes`,
  );

  return data;
};
